/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ComponentCanDeactivate } from './component-can-deactivate';
import { Directive, QueryList } from '@angular/core';

@Directive()
export abstract class ComponentsCanDeactivate extends ComponentCanDeactivate {
  abstract getChildren(): QueryList<any> | QueryList<any>[];

  canDeactivate() {
    let deactivate = true;

    const queryList: any[] = [];

    const children = this.getChildren();

    if (Array.isArray(children)) {
      children.forEach(item => {
        queryList.push(...item.toArray());
      });
    } else {
      queryList.push(...children.toArray());
    }

    queryList.forEach(form => {
      if (form.canDeactivate() === false) {
        deactivate = false;
      }
    });

    return deactivate;
  }
}
